import { TableContentSupplierDairySummaryReport, TableContentWithoutEditDateFromat } from '../../../Common/Table/tableContent';
import React from "react";
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const data = this.props.data;
        const rowNames = this.props.rowNames;
        const searchData = this.props.searchData;
        const totalRow = this.props.totalRow;
        const columeNames = this.props.columeNames;
        const inishialColumName = [{
        title: 'Date', field: 'weightReadTime', render: rowData => rowData.weightReadTime, headerStyle: {
            color: '#000000',
            textAlign: 'center',
            fontWeight: 'bold'
        }, cellStyle: { textAlign: 'left' }

    }]

        return (
            <div>
                <h3><center><u>Factory Item Status Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.estate}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date : </b> {searchData.toDate}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                    <div className="col"><b>Date/Time: </b> {new Date().toLocaleString()}</div>
                </div>
                <div className="row">
                        <div className="col pb-2 width4">
                            <table id="totalCropPdf">
                            <thead>
                                        <tr>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Date</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Reg No</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Collection Point</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Item Catogory</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Item Name</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Requested Quentity</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Approved Quentity</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Total Price</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Reason</th>
                                            <th style={{ fontWeight: "bold" }}rowSpan="2">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <TableContentSupplierDairySummaryReport
                                            data={data}
                                            contentRowNames={rowNames}
                                            hasEdit={false}
                                        />
                                    </tbody>
                                </table>
                        </div>
                        <hr />
                    
                </div>
            </div>
        );
    }
}